export const table_titles = [
	{ name: "#", size: 3, order: "" },
	{ name: "Nombre", size: 8, order: "name" },
	{ name: "Grupo Campo", size: 7, order: "estate_parent_name" },
	{ name: "Campo", size: 8, order: "estate_name" },
	{ name: "Ha", size: 5, order: "area" },
	{ name: "Especie", size: 8, order: "specie_name" },
	{ name: "Variedad", size: 8, order: "variety_name" },
	{ name: "Acción", size: 7, order: "" },
];

export const table_titles_with_sector = [
	{ name: "#", size: 3, order: "" },
	{ name: "Nombre", size: 25, order: "name" },
	{ name: "Grupo Campo", size: 25, order: "estate_parent_name" },
	{ name: "Campo", size: 25, order: "" },
	{ name: "Superficie Total", size: 10, order: "" },
	{ name: "Acción", size: 7, order: "" },
	{ name: "", size: 5, order: "" },
];

export const base_business_center = {
	customer_id: "",
	customer_name: "",
	id: "",
	name: "",
	plantation_distance_end: "",
	plantation_distance: "",
	rootstock: "",
	type_irrigation: "",
	conduction_system: "",
	year: "",
	area: "",
	estate_parent_id: "",
	category_id: "",
	specie: "",
	variety: "",
	crop_detail_id: "",
	business_center_type_id: "",
	species: [],
	varieties: [],
	quarters: [],
	estates: [],
	markets: [],
	harvest_date: "",
};

export const base_business_center_parents = {
	id: "",
	name: "",
	estate_parent_id: "",
	businessCenters: [],
	estates: [],
	slug: "",
	category_id: "",
	species: [],
	varieties: [],
	quarters: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	filter_type: "activos",
	filter_customer: "",
	filter_estate: "",
	filter_category: "",
	filter_specie: "",
	filter_variety: "",
	filter_quarter: "",
};
